export const BREAKPOINTS = {
    S: 767,
    L: 1023,
    XL: 1024,
} as const;

export const BREAKPOINT = {
    S: "S",
    L: "L",
    XL: "XL",
} as const;

export type BreakpointType = (typeof BREAKPOINT)[keyof typeof BREAKPOINT];

export const BREAKPOINT_ORDER: BreakpointType[] = [
    BREAKPOINT.S,
    BREAKPOINT.L,
    BREAKPOINT.XL,
];

export const DEVICE_TYPE = {
    MOBILE: "mobile",
    TABLET: "tablet",
    DESKTOP: "desktop",
} as const;

export type DeviceType = (typeof DEVICE_TYPE)[keyof typeof DEVICE_TYPE];
